import revive_payload_client_4sVQNw7RlN from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/nuxt-front-end-V2/nuxt-front-end/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_dyN8cpJ0Jb from "/home/nuxt-front-end-V2/nuxt-front-end/node_modules/nuxt-scroll-restoration/dist/runtime/plugin.js";
import onAppInit_hWq0wQUwOj from "/home/nuxt-front-end-V2/nuxt-front-end/plugins/onAppInit.js";
import i18n_sVHQBgnb3t from "/home/nuxt-front-end-V2/nuxt-front-end/plugins/i18n.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_dyN8cpJ0Jb,
  onAppInit_hWq0wQUwOj,
  i18n_sVHQBgnb3t
]